/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { Tooltip } from 'appkit-react/lib/Tooltip';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';

import {
    GET_BATCH_TESTS_FOR_FRY7Q, GET_QUARTER_FILTERED_BATCH_TESTS_FOR_FRY7Q, GET_SUMMARY_QUARTERS_FOR_FRY7Q, GET_DOWNLOADED_RESULT, GET_LATEST_BATCH_FOR_FRY7Q,
} from 'Apollo/Queries/Rules/Fry7qResults';
import {
    showReportMenuVar, getPreviousBatchVar, showBatchAlertVar, tenantIdVar,
    leftNavigationItemsVar, moduleIdVar, currentLeftMenuVar,
} from 'Apollo/config';
import { ModuleEnum } from 'constants';
import DiagnosticResultsUI from 'views/DiagnosticResults/components';
import crossReportImg from 'assets/images/cross-report-black.svg';
import StatusComponent from '../../../DiagnosticResults/components/StatusComponent';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem', color: '#464646' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const FRY7QLandingPage = () => {
    const history = useHistory();
    const location = useLocation();
    const [regulation, setRegulation] = useState(location.state.regulation);
    const [selectedQuarter, setSelectedQuarter] = useState('');
    const [oneTimeFlag, setOneTimeFlag] = useState(true);
    const showBatchAlert = useReactiveVar(showBatchAlertVar);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [queryError, setQueryError] = useState(false);
    const getPreviousBatch = useReactiveVar(getPreviousBatchVar);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo query to fetch batch tests result  */
    const [getBatchTestData, { loading: isLoading, data }] = useLazyQuery(GET_BATCH_TESTS_FOR_FRY7Q, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                getPreviousBatch,
                tenantId,
            },
        },
    });

    /* Apollo query to fetch getCurrentStatusOfLatestBatch */
    const [getCurrentStatusOfLatestBatch, {
        data: { getCurrentStatusOfLatestBatchForFRY7Q = {} } = {}, error: getCurrentStatusOfLatestBatchError, stopPolling,
    }] = useLazyQuery(GET_LATEST_BATCH_FOR_FRY7Q, {
        variables: {
            input: {
                tenantId,
            },
        },
        pollInterval: 20000,
        fetchPolicy: 'no-cache',
    });

    /* Apollo query to download batch test result  */
    const [
        getDownloadedResult, {
            loading: isDownloading, data: {
                getFRY7QSummaryDetailsForDownload = {},
            } = {},
        },
    ] = useLazyQuery(GET_DOWNLOADED_RESULT, {
        fetchPolicy: 'no-cache',
    });

    /* Apollo query fetch batch test result selected quarter  */
    const [getQuarterFilteredData, filteredBatchTests] = useLazyQuery(GET_QUARTER_FILTERED_BATCH_TESTS_FOR_FRY7Q, {
        fetchPolicy: 'no-cache',
    });

    /* Apollo query fetch to quarters  */
    const [getSummaryQuarter, summaryQuartersData] = useLazyQuery(GET_SUMMARY_QUARTERS_FOR_FRY7Q, {
        variables: {
            input: {
                tenantId,
            },
        },
    });

    const getLatestBatch = () => {
        stopPolling();
        setOneTimeFlag(true);
        getPreviousBatchVar(false);
        setShowSuccessAlert(false);
    };

    /* Breadcrumb items configuration */
    const breadcrumbItems = [
        {
            link: '',
            value: (
                <span
                    className="appkiticon icon-home-fill font-16"
                    onClick={
                        () => {
                            showReportMenuVar(false);
                            history.push('/');
                            leftNavigationItemsVar([]);
                            moduleIdVar(null);
                        }
                    }
                    role="presentation"
                />
            ),
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text">FRY7Q Diagnostic Results</span>,
        },
    ];

    /* status component fetched from diagonstic result folder */
    const getSpanStyle = status => (
        <StatusComponent
            status={status}
        />
    );

    /* Column configuration for batch test summary table */
    const columns = [
        {
            Header: 'Rule ID',
            accessor: 'ruleId',
            minWidth: 50,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { topTierApplicable, ruleId } } = row;
                return topTierApplicable === 'N' ? (
                    <Tooltip content={<span className="a-h6">Applicability dependent on Low tier or High tier categorization</span>} placement="top" tooltipTheme="light">
                        {ruleId}
                    </Tooltip>
                )
                    : (
                        <span>{ruleId}</span>
                    );
            },
        },
        {
            Header: 'Schedule / Part',
            accessor: 'schedule',
            minWidth: 120,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { topTierApplicable, schedule } } = row;
                return topTierApplicable === 'N' ? (
                    <Tooltip content={<span className="a-h6">Applicability dependent on Low tier or High tier categorization</span>} placement="top" tooltipTheme="light">
                        {schedule}
                    </Tooltip>
                )
                    : (
                        <span>{schedule}</span>
                    );
            },
        },
        {
            Header: 'MDRM',
            accessor: 'mdrmNumber',
            minWidth: 110,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { topTierApplicable, mdrmNumber } } = row;
                return topTierApplicable === 'N' ? (
                    <Tooltip content={<span className="a-h6">Applicability dependent on Low tier or High tier categorization</span>} placement="top" tooltipTheme="light">
                        {mdrmNumber}
                    </Tooltip>
                )
                    : (
                        <span>{mdrmNumber}</span>
                    );
            },
        },
        {
            Header: 'Associated rule',
            accessor: 'editTest',
            minWidth: 250,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { topTierApplicable, editTest } } = row;
                return topTierApplicable === 'N' ? (
                    <Tooltip content={<span className="a-h6">Applicability dependent on Low tier or High tier categorization</span>} placement="top" tooltipTheme="light">
                        {editTest}
                    </Tooltip>
                )
                    : (
                        <span>{editTest}</span>
                    );
            },
        },
        {
            Header: 'Rule description',
            accessor: 'ruleDdescription',
            minWidth: 250,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { topTierApplicable, ruleDescription } } = row;
                return topTierApplicable === 'N' ? (
                    <Tooltip content={<span className="a-h6">Applicability dependent on Low tier or High tier categorization</span>} placement="top" tooltipTheme="light">
                        {ruleDescription}
                    </Tooltip>
                )
                    : (
                        <span>{ruleDescription}</span>
                    );
            },
        },
        {
            Header: 'Enabled Y/N',
            accessor: 'isAactive',
            minWidth: 100,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { topTierApplicable, isActive } } = row;
                return topTierApplicable === 'N' ? (
                    <Tooltip content={<span className="a-h6">Applicability dependent on Low tier or High tier categorization</span>} placement="top" tooltipTheme="light">
                        {isActive}
                    </Tooltip>
                )
                    : (
                        <span>{isActive}</span>
                    );
            },
        },
        {
            Header: 'Rule applicable',
            accessor: 'topTierApplicable',
            minWidth: 117,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { topTierApplicable } } = row;
                return topTierApplicable === 'N' ? (
                    <Tooltip content={<span className="a-h6">Applicability dependent on Low tier or High tier categorization</span>} placement="top" tooltipTheme="light">
                        {topTierApplicable}
                    </Tooltip>
                )
                    : (
                        <span>{topTierApplicable}</span>
                    );
            },
        },
        {
            Header: 'Test status',
            accessor: 'testRunStatus',
            minWidth: 90,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { topTierApplicable, testRunStatus } } = row;
                return topTierApplicable && topTierApplicable.toLowerCase() === 'n' ? (
                    <span
                        className="appkiticon
                        icon-alert-outline"
                        style={{ color: '#FFB600', fontSize: '1.3rem', marginLeft: '1rem' }}
                    />
                ) : getSpanStyle(testRunStatus);
            },
        },
    ];

    /* Method for sidebar navigation */
    const onNavigate = () => {
        // method for sidebar navigation
    };

    /* Navigates to upload report page */
    const uploadReport = () => {
        history.push(
            {
                pathname: '/UploadReport',
            },
        );
    };

    /* Calls the  getDownloadedResult */
    const downloadResult = async () => {
        const quarter = Math.floor(selectedQuarter.getMonth() / 3 + 1);
        const year = selectedQuarter.getFullYear();
        const qtrValue = `q${quarter}_${year}`;
        getDownloadedResult({
            variables: {
                input: {
                    tenantId,
                    period: qtrValue,
                },
            },
        });
    };

    /* Navigates to result page of specific rule */
    const onNavigateToResult = row => {
        history.push(
            {
                pathname: '/fyresults',
                state: {
                    batchId: row.batchId,
                    ruleId: row.ruleId,
                    period: row.period,
                    regulation,
                },
            },
        );
    };

    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.RULEENGINE);
    }, []);
    /* Side effect when location state updates */
    useEffect(() => {
        setRegulation(location.state.regulation);
    }, [location]);

    /* Side effect when getPreviousBatch changed */
    useEffect(async () => {
        getBatchTestData();
        getSummaryQuarter();
        if (getPreviousBatch === true) {
            getCurrentStatusOfLatestBatch();
        }
    }, [getPreviousBatch]);

    /* Side effect when batchTestData changed to set selected quarter */
    useEffect(() => {
        if (data?.getBatchTestsForFRY7Q && data?.getBatchTestsForFRY7Q.length > 0) {
            const qtrValue = data.getBatchTestsForFRY7Q[0].period;
            const quarter = qtrValue.split('_')[0];
            const year = qtrValue.split('_')[1];
            let date;
            switch (quarter) {
                case 'q1':
                    date = new Date(year, 0, 1);
                    break;
                case 'q2':
                    date = new Date(year, 3, 1);
                    break;
                case 'q3':
                    date = new Date(year, 6, 1);
                    break;
                case 'q4':
                    date = new Date(year, 9, 1);
                    break;
                default:
                    break;
            }
            setSelectedQuarter(date);
        } else {
            setSelectedQuarter('');
        }
    }, [data]);

    /* Side effect when getCurrentStatusOfLatestBatchForFRY7Q changed */
    useEffect(() => {
        const isCurrentStatusForLatestBatchAvailable = getCurrentStatusOfLatestBatchForFRY7Q.length > 0 && Object.keys(getCurrentStatusOfLatestBatchForFRY7Q[0]).length > 0;

        if (isCurrentStatusForLatestBatchAvailable && (
            (getCurrentStatusOfLatestBatchForFRY7Q[0]).batchRunStatus === 'Completed'
                || (getCurrentStatusOfLatestBatchForFRY7Q[0]).batchRunStatus === 'Failed')) {
            showBatchAlertVar(false);
            stopPolling();
        }
        if (isCurrentStatusForLatestBatchAvailable && (getCurrentStatusOfLatestBatchForFRY7Q[0]).batchRunStatus === 'Completed') {
            setShowSuccessAlert(true);
        }
    }, [getCurrentStatusOfLatestBatchForFRY7Q, stopPolling]);

    /* Side effect when getCurrentStatusOfLatestBatchError changed */
    useEffect(() => {
        if (getCurrentStatusOfLatestBatchError) {
            stopPolling();
            setQueryError(true);
            showBatchAlertVar(false);
        }
    }, [getCurrentStatusOfLatestBatchError, stopPolling]);

    /* Side effect when selectedQuarter changed to refetch batch tests result */
    useEffect(() => {
        if (selectedQuarter !== '' && !getPreviousBatch) {
            const quarter = Math.floor(selectedQuarter.getMonth() / 3 + 1);
            const year = selectedQuarter.getFullYear();
            const qtrValue = `q${quarter}_${year}`;
            getQuarterFilteredData({
                variables: {
                    input: {
                        period: qtrValue,
                        tenantId,
                        pageNumber: 1,
                        pageSize: 100,
                    },
                },
            });
            setOneTimeFlag(false);
        }
    }, [selectedQuarter, getPreviousBatch]);

    /* Side effect when getFRY7QSummaryDetailsForDownload changed */
    useEffect(() => {
        if (getFRY7QSummaryDetailsForDownload && getFRY7QSummaryDetailsForDownload.length > 0) {
            const json = getFRY7QSummaryDetailsForDownload;
            const fields = Object.keys(json[0]);
            const replacer = (key, value) => (value === null ? '' : value);
            let csv = json.map(row => fields.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
            csv.unshift(fields.join(','));
            csv = csv.join('\r\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            saveAs(blob, `${regulation}_result.csv`);
        }
    }, [getFRY7QSummaryDetailsForDownload]);

    return (
        <DiagnosticResultsUI
            breadcrumbItems={breadcrumbItems}
            summaryQuartersData={summaryQuartersData}
            onNavigate={onNavigate}
            commonData={oneTimeFlag ? (data && data.getBatchTestsForFRY7Q) : (filteredBatchTests.data && filteredBatchTests.data.getFRY7QBatchTestsByQuarter)}
            columns={columns}
            selectedQuarter={selectedQuarter}
            setSelectedQuarter={setSelectedQuarter}
            uploadReport={uploadReport}
            onNavigateToResult={onNavigateToResult}
            pageName="FRY7Q Diagnostic Results"
            downloadResult={downloadResult}
            isDownloading={isDownloading}
            isBatchTestDataLoading={isLoading}
            latestBatch={getCurrentStatusOfLatestBatchForFRY7Q}
            getPreviousBatch={getPreviousBatch}
            showSuccessAlert={showSuccessAlert}
            getLatestBatch={getLatestBatch}
            showBatchAlert={showBatchAlert}
            queryError={queryError}
        />
    );
};

export default FRY7QLandingPage;
